import axios from "axios";

const URL_DICTIONARIES = import.meta.env.VITE_AUTH_DICTIONARIES;

export function RestoreZoneService (token, zoneId)  {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.put(
        `${URL_DICTIONARIES}/api/locations/v1/zones/${zoneId}/restore`,
        [],
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
  });
};